function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import clsx from 'clsx';
import { a, useSpring } from '@react-spring/web';
import { NavigationArrows, Slides } from "../../base";
import { TabsHeader } from "./tabs-base.component";
import "./tabs.style.scss";
const getCurrentInRange = (current = 0, length) => current >= 0 && current < length ? current : 0;
export const Tabs = props => {
  const {
    tabs,
    initial,
    animation,
    slideAnimation = true,
    initialSlide = false,
    className,
    current,
    onChange,
    components = {}
  } = props;
  const {
    Header = TabsHeader
  } = components;
  const containerRef = React.useRef(null);
  const ulRef = React.useRef(null);
  const initialTab = React.useMemo(() => current !== undefined ? getCurrentInRange(current, tabs.length) : getCurrentInRange(initial, tabs.length), []);
  const [currentTab, setCurrentTab] = React.useState(initialTab);
  const currentTabRef = React.useRef(initialTab);
  const naRef = React.useRef(null);
  const [indicator, indicatorRef] = useSpring(() => ({
    from: {
      width: 0,
      transform: 'translateX(0px)'
    },
    config: {
      duration: 200
    }
  }));
  React.useEffect(() => {
    if (current !== undefined) setCurrentTab(getCurrentInRange(current, tabs.length));
  }, [current]);
  const updateIndicator = React.useCallback(() => {
    if (ulRef.current) {
      const child = ulRef.current.children[currentTabRef.current];
      if (naRef.current) naRef.current.scrollTo(child, {
        duration: 200
      }, ulRef.current);
      const width = child.offsetWidth;
      const offset = child.offsetLeft;
      indicatorRef.start({
        to: {
          width,
          transform: `translateX(${offset}px)`
        }
      });
    }
  }, []);
  React.useEffect(() => {
    currentTabRef.current = currentTab;
    updateIndicator();
  }, [currentTab]);
  React.useEffect(() => {
    const onResize = () => updateIndicator();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  React.useEffect(() => {
    setTimeout(() => updateIndicator(), 100);
  }, []);
  const items = React.useMemo(() => tabs.map((tab, key) => _objectSpread(_objectSpread({}, tab), {}, {
    key,
    slide: tab.content
  })), [tabs]);
  const TabFC = React.useMemo(() => {
    if (tabs[currentTab]) return tabs[currentTab].content;
    return null;
  }, [tabs, currentTab]);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx('tabs-container', className)
  }, /*#__PURE__*/React.createElement(Header, {
    current: currentTab
  }, /*#__PURE__*/React.createElement(NavigationArrows, {
    watch: containerRef,
    ref: naRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs-header-container",
    ref: containerRef
  }, /*#__PURE__*/React.createElement("ul", {
    className: "tabs-header",
    ref: ulRef
  }, items.map((item, tabIndex) => /*#__PURE__*/React.createElement("li", {
    key: tabIndex,
    onClick: () => {
      if (current === undefined) setCurrentTab(tabIndex);else if (onChange) onChange(tabIndex);
    },
    className: clsx('tab-item-header', {
      'cursor-pointer': tabIndex !== currentTab,
      active: tabIndex === currentTab
    })
  }, /*#__PURE__*/React.createElement("span", null, item.header)))), /*#__PURE__*/React.createElement("div", {
    className: "tabs-active-item-indicator-wrapper"
  }, /*#__PURE__*/React.createElement(a.div, {
    className: "tabs-active-item-indicator",
    style: indicator
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "tabs-body"
  }, slideAnimation ? /*#__PURE__*/React.createElement(Slides, {
    current: currentTab,
    items: items,
    animation: animation,
    initialSlide: initialSlide
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, TabFC && /*#__PURE__*/React.createElement("div", {
    className: "w-100 h-100"
  }, /*#__PURE__*/React.createElement(TabFC, null)))));
};